import React from "react";
import { Switch, Spinner, HStack, Text } from "@chakra-ui/react";
import type { UserAssignment } from "newui/features/RolesPermissions/types/RolesPermissions.type";
import { useAssignmentMutations } from "newui/features/RolesPermissions/hooks/useUserAssignments";

interface UserFlagsToggleProps {
	user: UserAssignment;
}

// C14: template_creation is a per-USER flag. The toggle sends exactly {flag, enabled}; the server
// fans out across the user's live non-Bidder-Support assignment rows and returns the reconciled
// user-level boolean (ANY live row enabled). The UI never computes that boolean itself.
export const UserFlagsToggle = ({ user }: UserFlagsToggleProps) => {
	const { toggleFlagMutation } = useAssignmentMutations();
	const enabled = user.flags.template_creation;

	const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
		toggleFlagMutation.mutate({
			userId: user.id,
			payload: { flag: "template_creation", enabled: event.target.checked },
		});
	};

	return (
		<HStack spacing={2}>
			{toggleFlagMutation.isPending ? (
				<Spinner size="sm" data-testid={`flag-spinner-${user.id}`} />
			) : (
				<Switch
					id={`flag-${user.id}`}
					isChecked={enabled}
					onChange={handleToggle}
					isDisabled={toggleFlagMutation.isPending}
					aria-label="Toggle template creation"
					data-testid={`flag-toggle-${user.id}`}
				/>
			)}
			<Text className="text-sm text-gray-600">Template creation</Text>
		</HStack>
	);
};
